export default __webpack_public_path__ + "static/media/line-headline.38b76a69.svg";